import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Trash16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path d='M7.25 6.5V12.5H8.75V6.5H7.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.25 3.25H1.5V4.75H2.81506L3.71171 14.6131C3.77024 15.257 4.31008 15.75 4.95658 15.75H11.0434C11.6899 15.75 12.2297 15.257 12.2882 14.6131L13.1849 4.75H14.5V3.25H10.75C10.75 2.42613 10.5454 1.65628 9.94454 1.05545C8.88542 -0.00367373 7.11458 -0.00367373 6.05546 1.05545C5.45463 1.65628 5.25 2.42613 5.25 3.25ZM7.11612 2.11611C6.79907 2.43316 6.75 2.82754 6.75 3.25H9.25C9.25 2.82754 9.20093 2.43316 8.88388 2.11611C8.40246 1.63469 7.59754 1.63469 7.11612 2.11611ZM11.6787 4.75H4.32125L5.18488 14.25H10.8151L11.6787 4.75Z'
      fill='currentColor'
    />
  </Svg>
);

Trash16.displayName = 'Trash16';
export default Trash16;
